export function exportDateRange(dates) {
    const format = date => date instanceof Date && Number.isFinite(date.getTime())
        ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
        : "";
    const startDate = format(dates?.[0]);
    const endDate = format(dates?.[1]);
    const days = (Date.parse(endDate) - Date.parse(startDate)) / 86400000 + 1;
    const valid = Number.isFinite(days) && days >= 1 && days <= 31
        && startDate >= "2000-01-01" && endDate <= "2100-12-31";
    return { startDate, endDate, valid };
}
